import { render, staticRenderFns } from "./swap-big-and-small-image.vue?vue&type=template&id=41945e3d&scoped=true"
import script from "./swap-big-and-small-image.vue?vue&type=script&lang=js"
export * from "./swap-big-and-small-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41945e3d",
  null
  
)

export default component.exports